import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GeneralValidator, { generalValidator } from '../../../../libs/utility/validators/GeneralValidator';
import SelectDropdown from '../../../components/dropdown/selectdropdown/SelectDropdown';
import { HEADING } from '../../../components/heading/constants/constants';
import Heading from '../../../components/heading/Heading';
import TextInput from '../../../components/input/textinput/TextInput';
import styles from './Intermediary.styles';
import { componentKey as intermediaryComponentKey, setAddIntermediaryDataObjFieldsTouched, updateAddIntermediaryDataObj } from './IntermediarySlice';
import { componentKey as  dataLoaderComponentKey } from '../../loaders/dataloader/DataLoaderSlice';
import { getCountriesAndStatesList } from '../../loaders/dataloader/DataLoaderSaga';
import Button from '../../../components/button/Button';
import { BUTTON_TYPE } from '../../../components/button/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { getIntermediaryDetails, submitSaveIntermediary } from './IntermediarySaga';

export default function AddEditIntermediary({intermediaryIdForEdit, onPopupCloseCb, onSubmitCb}) {
    
    const { countriesList, statesList } = useSelector(state => state[dataLoaderComponentKey]);
    const { addIntermediaryDataObj, isSaveIntermediarySuccessful } = useSelector(state => state[intermediaryComponentKey]);

    const dispatch = useDispatch();

    useEffect(() => {
        if(intermediaryIdForEdit){
            dispatch(getIntermediaryDetails({id: intermediaryIdForEdit, countriesList, statesList}));
        }
    }, [])

    useEffect(() => {
        const USA = countriesList?.find(country => country?.Country_code === "US")
        dispatch(updateAddIntermediaryDataObj({ CountryCode: USA }));
    }, []);

    useEffect(() => {
        if (countriesList.length <= 0 || statesList.length <= 0) {
            dispatch(getCountriesAndStatesList())
        };
    }, []);

    useEffect(() => {
        if(isSaveIntermediarySuccessful){
            onSubmitCb();
            onPopupCloseCb();
        }
    }, [isSaveIntermediarySuccessful]);

    const onChangehandler = (event, rules) => {
        const { name, value } = event.target;

        if (rules) {
            const errors = generalValidator.validate(value, rules);
            dispatch(updateAddIntermediaryDataObj({ [name]: { value, errors, rules } }));
        }
        else {
            dispatch(updateAddIntermediaryDataObj({ [name]: { value } }));
        }
    };

    const handleSubmit = () => {
        dispatch(setAddIntermediaryDataObjFieldsTouched(true));
        if(!GeneralValidator.validateRequiredFields(addIntermediaryDataObj)){
            const convertedDataObj = {};
            for (const property in addIntermediaryDataObj) {
                if (property !== 'allRequiredFieldsTouched' && addIntermediaryDataObj.hasOwnProperty(property)) {
                    convertedDataObj[property] = addIntermediaryDataObj[property].value;
                }
            }
            dispatch(submitSaveIntermediary(convertedDataObj));
        }else{
            dispatch(addNotifications({ heading: "Required fields missing", message: "Please fill the required fields" }))
        }
    }

    return <>
    <div style={styles.container}>
        <div style={styles.headingRow}>
            <Heading type={HEADING.H1}>Add/Edit Intermediary</Heading>
        </div>
        <div style={styles.fieldRow}>
            <TextInput
                name="TIN"
                type="text"
                labelWTooltip={{ id: "tin-tooltip", label: "Enter the Intermediary’s TIN", tooltipText: "Enter the Intermediary’s TIN" }}
                placeHolder={"TIN"}
                value={addIntermediaryDataObj.TIN.value}
                onChangeCb={onChangehandler}
                rules={addIntermediaryDataObj.TIN.rules}
                errors={addIntermediaryDataObj.TIN.errors}
                formSubmitted={addIntermediaryDataObj.allRequiredFieldsTouched}
            />
        </div>
        <div style={styles.fieldRow}>
            <TextInput
                name="GIIN"
                type="text"
                labelWTooltip={{ id: "giin-tooltip", label: "Enter the Intermediary’s GIIN", tooltipText: "Enter the Intermediary’s GIIN" }}
                placeHolder={"GIIN"}
                value={addIntermediaryDataObj.GIIN.value}
                onChangeCb={onChangehandler}
                rules={addIntermediaryDataObj.GIIN.rules}
                errors={addIntermediaryDataObj.GIIN.errors}
                formSubmitted={addIntermediaryDataObj.allRequiredFieldsTouched}
            />
        </div>
        <div style={styles.fieldRow}>
            <TextInput
                name="FTIN"
                type="text"
                labelWTooltip={{ id: "ftin-tooltip", label: "Enter the Intermediary’s FTIN", tooltipText: "Enter the Intermediary’s FTIN" }}
                placeHolder={"FTIN"}
                value={addIntermediaryDataObj.FTIN.value}
                onChangeCb={onChangehandler}
                rules={addIntermediaryDataObj.FTIN.rules}
                errors={addIntermediaryDataObj.FTIN.errors}
                formSubmitted={addIntermediaryDataObj.allRequiredFieldsTouched}
            />
        </div>
        <div style={styles.fieldRow}>
            <TextInput
                name="Name"
                type="text"
                labelWTooltip={{ id: "name-tooltip", label: "Enter the Intermediary’s Name", tooltipText: "Enter the Intermediary’s Name" }}
                placeHolder={"Name"}
                value={addIntermediaryDataObj.Name.value}
                onChangeCb={onChangehandler}
                rules={addIntermediaryDataObj.Name.rules}
                errors={addIntermediaryDataObj.Name.errors}
                formSubmitted={addIntermediaryDataObj.allRequiredFieldsTouched}
            />
        </div>
        <div style={styles.fieldRow}>
            <TextInput
                name="Address"
                labelWTooltip={{ id: "address-tooltip", label: "Enter the Intermediary’s Address details.", tooltipText: "Enter the Intermediary’s Address details." }}
                placeHolder='Enter address'
                value={addIntermediaryDataObj.Address?.value}
                onChangeCb={onChangehandler}
                rules={addIntermediaryDataObj.Address.rules}
                errors={addIntermediaryDataObj.Address.errors}
                formSubmitted={addIntermediaryDataObj.allRequiredFieldsTouched}
            />
        </div>
        <div style={{...styles.formRow, ...styles.fieldRow}}>
            <div style={styles.fieldContainer}>
                <SelectDropdown
                    label="Country"
                    placeHolder="Enter country"
                    name="CountryCode"
                    value={{ label: addIntermediaryDataObj.CountryCode.label, value: addIntermediaryDataObj.CountryCode.value }}
                    onSelectCb={(name, selectedOption) => dispatch(updateAddIntermediaryDataObj({ [name]: selectedOption }))}
                    options={countriesList}
                    rules={addIntermediaryDataObj.CountryCode?.rules}
                    errors={addIntermediaryDataObj.CountryCode?.errors}
                    formSubmitted={addIntermediaryDataObj.allRequiredFieldsTouched}
                />
            </div>
            <div style={styles.fieldContainer}>
                {addIntermediaryDataObj.CountryCode.value === "US" ?
                    <SelectDropdown
                        label="State/Province"
                        placeHolder="Enter state/province"
                        name="StateorProvinceCode"
                        value={{label: addIntermediaryDataObj.StateorProvinceCode.label, value: addIntermediaryDataObj.StateorProvinceCode.value}}
                        onSelectCb={(name, selectedOption) => dispatch(updateAddIntermediaryDataObj({ [name]: selectedOption }))}
                        options={statesList}
                        rules={addIntermediaryDataObj.StateorProvinceCode?.rules}
                        errors={addIntermediaryDataObj.StateorProvinceCode?.errors}
                        formSubmitted={addIntermediaryDataObj.allRequiredFieldsTouched}
                    />

                    :

                    <TextInput
                        label="State/Province"
                        placeHolder='Enter state/province name'
                        name="StateorProvinceCode"
                        value={addIntermediaryDataObj.StateorProvinceCode.value}
                        onChangeCb={(e) => dispatch(updateAddIntermediaryDataObj({ [e.target.name]: { label: e.target.value, value: e.target.value } }))}
                        rules={addIntermediaryDataObj.StateorProvinceCode?.rules}
                        errors={addIntermediaryDataObj.StateorProvinceCode?.errors}
                        formSubmitted={addIntermediaryDataObj.allRequiredFieldsTouched}
                    />}
            </div>
        </div>
        <div style={{...styles.formRow, ...styles.fieldRow}}>
            <div style={styles.fieldContainer}>
                <TextInput
                    name="City"
                    label="City"
                    placeHolder='Enter city name'
                    value={addIntermediaryDataObj.City?.value}
                    onChangeCb={onChangehandler}
                    rules={addIntermediaryDataObj.City?.rules}
                    errors={addIntermediaryDataObj.City?.errors}
                    formSubmitted={addIntermediaryDataObj.allRequiredFieldsTouched}
                />
            </div>
            <div style={styles.fieldContainer}>
                <TextInput
                    name="ZipCode"
                    label="Zip Code"
                    placeHolder='Enter Zip Code'
                    value={addIntermediaryDataObj.ZipCode?.value}
                    onChangeCb={onChangehandler}
                    rules={addIntermediaryDataObj.ZipCode?.rules}
                    errors={addIntermediaryDataObj.ZipCode?.errors}
                    formSubmitted={addIntermediaryDataObj.allRequiredFieldsTouched}
                />
            </div>
        </div>
        <div style={styles.submitButtonRow}>
            <Button style={styles.submitButton} type={BUTTON_TYPE.PRIMARY} onClickCb={handleSubmit} >Submit</Button>
        </div>
    </div>
    </>
}